import { marketingSite } from "./marketingSites.ts";

type RouteEntry = {
  id: string;
  parentId?: string;
  path?: string;
  index?: boolean;
};

export type HydrationRoutes = Record<string, RouteEntry | undefined>;

/**
 * Cloudflare serves the /playr prerender at /. Match its original route IDs
 * there too, so HydratedRouter can reuse that HTML and its preloaded modules.
 * Only the dedicated PLAYR host changes; the platform keeps its home index.
 */
export function preparePlayrHydration(
  routes: HydrationRoutes | undefined,
  url: URL
): boolean {
  if (marketingSite(url) !== "playr" || url.pathname !== "/" || !routes)
    return false;
  const playr = routes["routes/playr/_index"];
  if (!playr || playr.parentId !== "routes/_marketing/layout") return false;

  delete routes["routes/_index"];
  delete playr.path;
  playr.index = true;
  return true;
}

/** Keep the prerendered tab anchors consistent with their visible root URL. */
export function preparePlayrLinks(document: Document): void {
  for (const link of document.querySelectorAll<HTMLAnchorElement>(
    'a[href^="/playr"]'
  )) {
    const href = link.getAttribute("href");
    if (href)
      link.setAttribute("href", href.replace(/^\/playr\/?(?=[?#]|$)/, "/"));
  }
}
